import actions from './actions';

const initialState = {
  initialData: [],
  data: [],
  filters: {
    columns: {},
    dateRange: {
      start: null,
      end: null,
    },
  },
  loading: false,
  error: null,
  allOrderStatus: {
    loading: false,
    data: [],
    error: null,
  },
};

const singleOrderInitialState = {
  data: {
    customer: {},
    items: [],
    delivery_address: {},
  },
  loading: false,
  error: null,
  editAddress: {
    loading: false,
    data: null,
    error: null,
  },
  editCustomizatoinJson: {
    loading: false,
  },
  reGeneratePdf: {
    /**
     * [orderItemId]: {
     *  loading: true | false
     * }
     */
    //
    orderStatusFormLoading: false,
  },
};

const {
  FILTER_ORDER_BEGIN,
  FILTER_ORDER_SUCCESS,
  FILTER_ORDER_ERR,
  SET_ORDER_FILTER_COLUMN,
  SET_ORDER_FILTER_RANGE,
  RESET_SET_ORDER_FILTERS,
  GET_ALL_ORDERS_BEGIN,
  GET_ALL_ORDERS_SUCCESS,
  GET_ALL_ORDERS_ERR,
  GET_ALL_ORDER_STATUS_BEGIN,
  GET_ALL_ORDER_STATUS_SUCCESS,
  GET_ALL_ORDER_STATUS_ERR,
  GET_SINGLE_ORDER_BEGIN,
  GET_SINGLE_ORDER_SUCCESS,
  GET_SINGLE_ORDER_ERR,
  SINGLE_ORDER_CLEAR,
  EDIT_ORDER_ADDRESS_BEGIN,
  EDIT_ORDER_ADDRESS_ERR,
  EDIT_ORDER_ADDRESS_SUCCESS,
  EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_BEGIN,
  EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_ERROR,
  EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_SUCCESS,
  RE_GENERATE_PDF_BEGIN,
  RE_GENERATE_PDF_ERROR,
  RE_GENERATE_PDF_SUCCESS,
  UPDATE_ORDER_STATUS_BEGIN,
  UPDATE_ORDER_STATUS_ERROR,
  UPDATE_ORDER_STATUS_SUCCESS,
} = actions;

const ordersReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ALL_ORDERS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_ORDERS_SUCCESS:
      return {
        ...state,
        data,
        initialData: data,
        filteredByDateData: data,
        loading: false,
      };
    case GET_ALL_ORDERS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_ALL_ORDER_STATUS_BEGIN:
      return {
        ...state,
        allOrderStatus: {
          ...state.allOrderStatus,
          error: null,
          loading: true,
        },
      };
    case GET_ALL_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        allOrderStatus: {
          data,
          error: null,
          loading: false,
        },
      };
    case GET_ALL_ORDER_STATUS_ERR:
      return {
        ...state,
        allOrderStatus: {
          data: [],
          error: err,
          loading: false,
        },
      };
    case FILTER_ORDER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FILTER_ORDER_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FILTER_ORDER_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case SET_ORDER_FILTER_COLUMN:
      return {
        ...state,
        filters: {
          ...state.filters,
          columns: {
            ...state.filters.columns,
            [action.column]: action.value,
          },
        },
      };
    case SET_ORDER_FILTER_RANGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          dateRange: {
            start: action.start,
            end: action.end,
          },
        },
      };
    case RESET_SET_ORDER_FILTERS:
      return {
        ...state,
        filters: {
          columns: {},
          dateRange: {
            start: null,
            end: null,
          },
        },
      };
    default:
      return state;
  }
};

const singleOrderReducer = (state = singleOrderInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_SINGLE_ORDER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_ORDER_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_SINGLE_ORDER_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case SINGLE_ORDER_CLEAR:
      return singleOrderInitialState;
    case EDIT_ORDER_ADDRESS_BEGIN:
      return {
        ...state,
        editAddress: {
          ...state.editAddress,
          data: null,
          loading: true,
        },
      };
    case EDIT_ORDER_ADDRESS_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          delivery_address: data,
        },
        editAddress: {
          ...state.editAddress,
          data,
          loading: false,
        },
      };
    case EDIT_ORDER_ADDRESS_ERR:
      return {
        ...state,
        editAddress: {
          ...state.editAddress,
          err,
          loading: false,
        },
      };
    case EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_SUCCESS:
      return {
        ...state,
        editCustomizatoinJson: {
          loading: false,
        },
      };
    case EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_ERROR:
      return {
        ...state,
        editCustomizatoinJson: {
          loading: false,
        },
      };
    case EDIT_ORDER_ITEM_CUSTOMIZATION_JSON_BEGIN:
      return {
        ...state,
        editCustomizatoinJson: {
          loading: true,
        },
      };
    case RE_GENERATE_PDF_BEGIN:
      return {
        ...state,
        reGeneratePdf: {
          ...state.reGeneratePdf,
          [action.orderItemId]: {
            loading: true,
          },
        },
      };
    case RE_GENERATE_PDF_ERROR:
      return {
        ...state,
        reGeneratePdf: {
          ...state.reGeneratePdf,
          [action.orderItemId]: {
            loading: false,
          },
        },
      };
    case RE_GENERATE_PDF_SUCCESS:
      return {
        ...state,
        reGeneratePdf: {
          ...state.reGeneratePdf,
          [action.orderItemId]: {
            loading: false,
          },
        },
      };
    case UPDATE_ORDER_STATUS_BEGIN:
      return {
        ...state,
        orderStatusFormLoading: true,
      };
    case UPDATE_ORDER_STATUS_ERROR:
      return {
        ...state,
        orderStatusFormLoading: false,
      };
    case UPDATE_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        orderStatusFormLoading: false,
      };
    default:
      return state;
  }
};

export { ordersReducer, singleOrderReducer };
